import React, { useState, useEffect } from 'react';
import { Activity } from 'lucide-react';
import { useDarkMode } from '../../../contexts/DarkModeContext';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../firebase';

const SystemLogs = () => {
  const { isDarkMode } = useDarkMode();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLogs();
  }, []);

  const loadLogs = async () => {
    try {
      setLoading(true);
      const getSystemLogs = httpsCallable(functions, 'getSystemLogs');
      const result = await getSystemLogs({ limit: 50 });
      setLogs(result.data.logs);
    } catch (error) {
      console.error('Error loading logs:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-emerald-500"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className={`text-3xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
          System Logs
        </h1>
        <p className={`mt-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
          View admin activity and system events
        </p>
      </div>

      <div className={`p-6 rounded-[24px] border ${
        isDarkMode ? 'bg-[#111111] border-gray-800' : 'bg-white border-gray-100'
      }`}>
        <div className="flex items-center gap-3 mb-4">
          <Activity className={`w-5 h-5 ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`} />
          <h2 className={`text-xl font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            Recent Activity
          </h2>
        </div>

        <div className="space-y-2">
          {logs.map(log => (
            <div
              key={log.id}
              className={`p-4 rounded-xl ${isDarkMode ? 'bg-[#1A1A1A]' : 'bg-gray-50'}`}
            >
              <div className="flex items-center justify-between">
                <p className={`font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                  {log.action}
                </p>
                <p className={`text-xs ${isDarkMode ? 'text-gray-500' : 'text-gray-500'}`}>
                  {new Date(log.timestamp).toLocaleString()}
                </p>
              </div>
              <p className={`text-sm mt-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                Admin UID: {log.adminUid}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SystemLogs;
